import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { LoginEmailModule } from 'src/app/components/login-email/login-email.module';
import { LoginComponent } from 'src/app/components/login/login.component';
import { LogoModule } from 'src/app/components/logo/logo.module';

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, MatButtonModule, LoginEmailModule, MatCardModule, LogoModule],
  exports: [LoginComponent],
})
export class LoginModule {}
